module.exports = __webpack_public_path__ + "img/icon_mine_chain.764ac9e5.png";